import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/ducks';

import Text from 'components/Text';
import { Row, Column } from 'components/Layout/Grid';
import { Button } from 'components/Button';
import RadioInput from 'components/RadioInput';
import Form from 'components/Form';
import Input from 'components/Input';
import { SupplierSelect } from 'components/SupplierSelect';

import IconSuccess from 'img/success-img.svg';

import SupplierService from 'services/supplier.service';

import { IOption } from 'components/Select/interface';
import { SupplierProps } from 'models/Supplier';
import { EnumUserType, IUser } from 'models/User';


export const AddExternalUserSlider: React.FC = () => {
  const slider = useSelector((state: RootState) => state.slider);
  const sliderUser = slider?.state?.userProp;
  const sliderSuppliers = slider?.state?.suppliers as SupplierProps[];
  const sliderLoggedUser = slider?.state?.loggedUser as IUser;
  const isSupplier = sliderLoggedUser?.userType == EnumUserType.SUPPLIER;

  const [loading, setLoading] = useState(false);
  const [wasLinked, setWasLinked] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [allSupplier, setAllSupplier] = useState<IOption[]>([]);
  const [newUserData, setNewUserData] = useState<any>({
    email: sliderUser?.email,
    roles: ['supplier'],
    supplierId: sliderUser?.supplierId,
  });

  const dispatch = useDispatch();
  const _supplierService = new SupplierService();

  const textButtonSave = 'Enviar Convite';

  function handleSuppliers() {
    if (!sliderSuppliers) return;

    const _supplierOption: Array<IOption> = new Array<IOption>({
      value: '',
      label: 'SELECIONE'
    });

    sliderSuppliers.sort((a, b) => a.name.localeCompare(b.name));
    Object.keys(sliderSuppliers).forEach((key: any) => {
      _supplierOption.push({
        value: sliderSuppliers[key].id,
        label: sliderSuppliers[key].name,
      });
    });

    setAllSupplier(_supplierOption);

    if (!newUserData.supplierId && _supplierOption.length > 0) {
      setNewUserData((prev: any) => ({
        ...prev,
        supplierId: ''
      }));
    }
  }

  async function inviteUser() {
    setLoading(true);
    setErrorMessage('');
    const supplierId = isSupplier ? sliderLoggedUser?.supplierId : newUserData.supplierId;

    await _supplierService
      .inviteSupplier(
        newUserData.email,
        supplierId,
        newUserData.roles,
      )
      .then((result: any) => {
        if (result?.status === 200) {

          dispatch({ type: 'CLOSE_TOAST' });

          setWasLinked(result.data?.wasLinked ?? false);

          dispatch({ type: 'HIDE_TITLE' });
          return setSuccess(true);
        }

        setErrorMessage(
          result.response.data.data || 'Ocorreu um erro durante a requisição.'
        );
        setLoading(false);
      });
  }

  function getSucessMessage() {
    return wasLinked
      ? 'Identificamos que o usuário já possui cadastro no Customer Care.' +
      '\nEle receberá por e-mail uma notificação informando a inclusão do acesso a essa empresa'
      : 'O usuário receberá por e-mail um link para completar seu cadastro';
  }

  function onCloseSlider() {
    if (slider?.state?.currentPage > 0) {
      slider?.state?.setCurrentPage(0);
    } else {
      slider?.state?.getUsers();
    }
    dispatch({ type: 'CLOSE_SLIDER' });
    dispatch({ type: 'SHOW_TITLE' });
  }

  useEffect(() => {
    handleSuppliers();
  }, []);

  return !success ? (
    <Form
      className=""
      id="add_new_user_form"
      onValidate={() => inviteUser()}
    >
      <Column className="mt-3 flex-1">
        <Column>
          <Text
            className="mr-2 mb-1 color-blue-gray"
            size={12}
            weight="bold"
          >
            E-mail*
          </Text>
          <Input
            required
            onChange={(e: any) =>
              setNewUserData({ ...newUserData, email: e.target.value.toLowerCase() })
            }
            className="w-100"
            type="email"
            value={newUserData.email}
            placeholder="E-mail"
          />
        </Column>
        {!isSupplier && <Column className="mt-4">
          <Text
            className="mr-2 mb-1 color-blue-gray"
            size={12}
            weight="bold"
          >
            Fornecedor*
          </Text>
          <SupplierSelect
            list={sliderSuppliers}
            onChange={(e) => setNewUserData({ ...newUserData, supplierId: e.target.value })}
            name="Fornecedor*"
            value={newUserData.supplierId}
            options={allSupplier}
            required
          />
        </Column>}
        <Column className="mt-4">
          <Text className="color-blue-gray mb-2">Nível de acesso*</Text>
          <Row>
            <Row className="mr-2">
              <RadioInput
                id="radio_administrator"
                onClick={() =>
                  setNewUserData({ ...newUserData, roles: ['administrator'] })
                }
                checked={
                  newUserData.roles && newUserData.roles[0] === 'administrator'
                }
              >
                <Text>Administrador</Text>
              </RadioInput>
            </Row>
            <Row>
              <RadioInput
                id="radio_collaborator"
                onClick={() =>
                  setNewUserData({ ...newUserData, roles: ['supplier'] })
                }
                checked={newUserData.roles && newUserData.roles[0] === 'supplier'}
              >
                <Text>Colaborador</Text>
              </RadioInput>
            </Row>
          </Row>
        </Column>
        {errorMessage && (
          <Row className="mt-2">
            <Text size={12} className="animated fadeIn mt-1 color-danger">
              {errorMessage}
            </Text>
          </Row>
        )}
        <Row className="mt-3 align-center justify-center">
          <Button
            form="add_new_user_form"
            spinnerColor="#0E4C54"
            isRequesting={loading}
            disabled={loading}
            className="outline bg-primary flex-sm-1 align-center justify-center d-flex pr-5 pl-5"
          >
            <Text className="color-primary font-bold">{textButtonSave}</Text>
          </Button>
        </Row>
      </Column>
    </Form>
  ) : (
    <Column className="w-100 h-100 align-center justify-center">
      <img src={IconSuccess} alt="" />
      <Text className="mt-2 color-blue-gray font-bold">
        Convite enviado com sucesso
      </Text>
      <Text className="text-center text-wrap mt-3 color-blue-gray" size={12}>
        {getSucessMessage()}
      </Text>
      <Button onClick={onCloseSlider} className="outline mt-4" width="auto">
        <Text className="color-primary font-bold px-3">Fechar</Text>
      </Button>
    </Column>
  );
};